module.exports = __webpack_public_path__ + "media/flags/zw-bf3ca7ab.svg";